import React, {FC, useRef} from 'react'
import {KTSVG} from '../../helpers'
import * as Yup from 'yup'
import {TextInput} from '../content/forms'
import {useFormik} from 'formik'
import {Post} from '../../../setup'
import {AddToContactsInterface, InitialValuesAddToContactsInterface} from './types'
import {useStatusMessage} from '../../../app/features'
import {useNotifications} from '../../../app/@contexts'
import {Modal} from './Modal'

const Schema = Yup.object().shape({
    first_name: Yup.string().min(3, 'Au moins 3 lettres').max(15, 'Maximum 15 lettres'),
    last_name: Yup.string().min(3, 'Au moins 3 lettres').max(15, 'Maximum 15 lettres'),
    companyName: Yup.string().min(3, 'Au moins 3 lettres').max(50, 'Maximum 50 lettres'),
    street: Yup.string().min(7, 'Au moins 7 lettres').max(100, 'Maximum 100 lettres'),
    email: Yup.string().email('Format d\'e-mail incorrect').min(12, 'Au moins 12 symboles').max(50, 'Maximum 50 symboles'),
    number: Yup.string().matches(/^\d+$/, 'Seulement les chiffres'),
})

const ONE_CONTACT = process.env.REACT_APP_MAILING_ONE_CONTACT_CREATE || '/v2/subscribers'

const AddToContacts: FC<AddToContactsInterface> = ({index, initialValues, textIcon, triggerReload}) => {

    return (
        <>
            <Modal
                button={{
                    bg: 'primary',
                    tooltip: 'Créer',
                    text: textIcon ? 'Créer' : undefined,
                    icon: {show: true, svg: 'abstract/abs011'},
                }}
                modal={{
                    id: `add_to_contacts_${index}`,
                    size: 'lg',
                    content: <Content triggerReload={triggerReload} initialValues={initialValues} />,
                }}
            />
        </>
    )
}

export {AddToContacts}

const Content: FC<{
    initialValues: InitialValuesAddToContactsInterface
    triggerReload: () => void
}> = ({initialValues, triggerReload}) => {

    const closeRef = useRef<HTMLButtonElement | null>(null)
    const {formState, setLoading} = useStatusMessage()
    const {setToast} = useNotifications()

    const onSubmit = async (values: InitialValuesAddToContactsInterface, {setSubmitting}: {
        setSubmitting: (isSubmitting: boolean) => void
    }) => {

        setLoading(true)
        setSubmitting(false)

        try {
            const {status, message} = await Post<any>(ONE_CONTACT, values)

            console.log(status, message)

            if (status === 200) {
                setToast({type: 'success', text: {title: 'Contact', message: 'Contact ajouté avec succès'}})
                setTimeout(() => {
                    if (closeRef.current) {
                        formik.resetForm()
                        closeRef.current?.click()
                        triggerReload()
                    }
                }, 1000)
            }

            if (status === 400) {
                setToast({type: 'error', text: {title: 'Contact', message}})
            }

        } catch (err) {
            console.error('Error submitting the form:', err)
        } finally {
            setLoading(false)
            setSubmitting(false)
        }
    }

    const formik = useFormik({
        initialValues,
        validationSchema: Schema,
        enableReinitialize: true,
        onSubmit,
    })

    const renderTextInput = (label: string, name: string) => (
        <div className="col-12 col-sm-6">
            <TextInput label={label} name={name} formik={formik} flex={'row'} />
        </div>
    )

    return (
        <form onSubmit={formik.handleSubmit}>
            <div className="modal-header">
                <h2>Ajouter aux contacts</h2>
                <div className="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal">
                    <KTSVG path="/media/icons/duotune/arrows/arr061.svg" className="svg-icon-1" />
                </div>
            </div>
            <div className="modal-body p-3 p-sm-5  p-md-7">
                <div className="row">
                    {renderTextInput('Prénom', 'first_name')}
                    {renderTextInput('Nom', 'last_name')}
                    {renderTextInput('E-mail', 'email')}
                    {renderTextInput('Adresse', 'street')}
                    {renderTextInput('Entreprise', 'companyName')}
                    {renderTextInput('Téléphone', 'number')}
                </div>
            </div>
            <div className="modal-footer">
                <button type="submit" className="btn btn-sm btn-primary me-2 px-6"
                        disabled={formState.loading}>
                    {formState.loading ? (
                        <span className="indicator-progress d-block">
                                S'il vous plaît, attendez... <span
                            className="spinner-border spinner-border-sm align-middle ms-2" />
                            </span>
                    ) : (
                        'Sauvegarder'
                    )}
                </button>
                <button type="button"
                        className="btn btn-sm btn-light me-2 px-6"
                        data-bs-dismiss="modal"
                        onClick={() => formik.resetForm()}
                        ref={closeRef}
                >
                    Fermer
                </button>
            </div>
        </form>
    )
}

